export const MAX_TARGET_APPLICATIONS_SIZE = 5000;

export class CreateTaskResult {
  readonly ok: boolean;
  readonly applicationErrors: ApplicationError[] | null;
  readonly summary: TaskSummary | null;

  constructor(
    ok: boolean,
    applicationErrors: ApplicationError[] | null,
    summary: TaskSummary | null,
  ) {
    this.ok = ok;
    this.applicationErrors = applicationErrors;
    this.summary = summary;
  }

  static fromJSON(json: CreateTaskResult): CreateTaskResult {
    return new CreateTaskResult(
      json.ok,
      json.applicationErrors
        ? ApplicationError.fromJSONArray(json.applicationErrors)
        : null,
      json.summary ? TaskSummary.fromJSON(json.summary) : null,
    );
  }
}

export class TaskSummary {
  readonly procedureID: string;
  readonly targetApplicationsCount: number;
  readonly latestCreatedAt: Date;
  readonly earliestCreatedAt: Date;

  constructor(
    procedureID: string,
    targetApplicationsCount: number,
    latestCreatedAt: Date,
    earliestCreatedAt: Date,
  ) {
    this.procedureID = procedureID;
    this.targetApplicationsCount = targetApplicationsCount;
    this.latestCreatedAt = latestCreatedAt;
    this.earliestCreatedAt = earliestCreatedAt;
  }

  static fromJSON(json: TaskSummary): TaskSummary {
    return new TaskSummary(
      json.procedureID,
      json.targetApplicationsCount,
      new Date(json.latestCreatedAt),
      new Date(json.earliestCreatedAt),
    );
  }

  static fromJSONArray(json: TaskSummary[]): TaskSummary[] {
    if (!json) {
      return [];
    }
    return json.map(TaskSummary.fromJSON);
  }
}

export type ErrorCode =
  | "InvalidCSV"
  | "TooManyApplications"
  | "MultipleProcedureIDsFound"
  | "UnexpectedError";

export type ErrorCodeForApplication =
  | "ApplicationNotFound"
  | "InvalidStatus"
  | "ApplicationRemovalScheduled"
  | "ApplicationIsDuplicated"
  | "HasUnhandledIssueRequest";
export const RegisterErrorMessages: Record<ErrorCode, string> = {
  InvalidCSV: "CSVの構造が正しくありません。",
  TooManyApplications: `一度に削除できる申請数を超えています。
  一度に削除できる申請数は${MAX_TARGET_APPLICATIONS_SIZE}件までです。`,
  MultipleProcedureIDsFound:
    "異なる手続きの申請IDが指定されています。同一手続きの申請IDを指定してください。",
  UnexpectedError:
    "予期しないエラーが発生しました。時間をおいて再度実行してください。",
};

export class ApplicationError {
  readonly applicationID: string;
  readonly errorCode: ErrorCodeForApplication;
  readonly errDetail: string;

  constructor(
    applicationID: string,
    errorCode: ErrorCodeForApplication,
    errDetail: string,
  ) {
    this.applicationID = applicationID;
    this.errorCode = errorCode;
    this.errDetail = errDetail;
  }

  static fromJSON(json: ApplicationError): ApplicationError {
    return new ApplicationError(
      json.applicationID,
      json.errorCode,
      json.errDetail,
    );
  }

  static fromJSONArray(json: ApplicationError[]): ApplicationError[] {
    if (!json) {
      return [];
    }
    return json.map(ApplicationError.fromJSON);
  }
}
